import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ApiService } from '../../utils/api.service';
import { HttpParams } from '@angular/common/http';
import { Registration } from '../../models';

export interface CreatedRegistration {
  id: string;
  member: {
    emailAddress: string;
    id: string;
  };
}

@Injectable()
export class RegistrationService {

  path = 'registrations';
  constructor(
    private apiService: ApiService,
  ) {
  }

  create(
    instanceId: string,
    memberUuids: string[] = [],
    memberEmails: string[] = [],
  ): Observable<CreatedRegistration[]> {
    let params = new HttpParams();

    memberUuids.forEach(uuid => {
      params = params.append('memberUuid[]', uuid);
    });

    memberEmails.forEach(email => {
      params = params.append('memberEmail[]', email);
    });

    let url = `course_instances/${instanceId}/registrations?`;
    url += params.toString();

    return this.apiService.post(url)
      .pipe(
        map(registrations => registrations.map(registration => new Registration(registration))),
      );
  }

  createSingle(instanceId: string, memberUuid: string): Observable<CreatedRegistration> {
    return this.create(instanceId, [memberUuid])
      .pipe(
        map(registrations => registrations[0]),
      );
  }

  setAbsent(courseInstanceId: string, memberId: string, isAbsent: boolean): Observable<null> {
    return this.apiService.patch(
      `members/${memberId}/course_instances/${courseInstanceId}/registration`,
      {isAbsent},
    );
  }

  downloadCertificate(registrationId: string, isInternal = true): Observable<Response> {
    const internalPath = `internal_registrations/${registrationId}/end-of-training-certificate`;
    const externalPath = `external_registrations/${registrationId}/training-contract`;

    return this.apiService.download(isInternal ? internalPath : externalPath);
  }
}
